import { render } from "./FactSheet.component.html?vue&type=template&id=20702704&scoped=true&ts=true&external"
import script from "./FactSheet.component.ts?vue&type=script&lang=ts&external"
export * from "./FactSheet.component.ts?vue&type=script&lang=ts&external"

import "./FactSheet.scoped.component.scss?vue&type=style&index=0&id=20702704&scoped=true&lang=scss&external"
import "./FactSheet.component.scss?vue&type=style&index=1&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20702704"]])

export default __exports__